import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";

import MultiSelect from "../../components/multi-select/multi-select";
import CheckBox from "../../components/check-box/check-box";
import PagePopup from "../../components/page-popup/page-popup";
import Heading from "../../components/heading/heading";
import Cta from "../../components/cta/cta";
import PremiumBadge from "../../components/premium-badge/premium-badge";
import SelectDropdown from "../../components/select-dropown/select-dropdown";
import TextInput from "../../components/text-input/text-input";

import { industriesData } from "../../data/industries.json";
import { ideaStagesData } from "../../data/idea-stages.json";
import { hoursPerWeekData } from "../../data/hours-per-week.json";
import { skillsData } from "../../data/skills.json";
import { founderContactsFilters } from "../../data/founder-contacts-filters.json";

import "./user-grid-filters.scss";

const portalNode = process.browser
  ? document.getElementById("page-portal")
  : null;

class UserGridFilters extends PureComponent {
  updateValue = ({ forLabel, value }) => {
    this.props.updateValue({
      forLabel,
      value,
    });
  };

  toggleSelection = ({ forLabel, id }) => {
    this.props.toggleSelection({
      forLabel,
      id,
    });
  };

  render() {
    const {
      filterOverlayActive,
      FHasIdeaForStartup,
      FLookingToJoinStartupAsFounder,
      FHasSkills,
      FIdeaStages,
      FHoursPerWeekData,
      FIndustriesData,
      FLocationByCity,
      FLocationByCountry,
      FLastActive,
      FContacts,
      FKeywordSearch,
      toggleFiltersOpen,
      applyFilters,
      resetFilters,
      me,
    } = this.props;

    const isPremiumUser = me && me.hasValidCoFounderSubscription;

    return (
      <>
        {portalNode &&
          filterOverlayActive &&
          ReactDOM.createPortal(
            <PagePopup
              togglePopup={toggleFiltersOpen}
              modifierClass="user-grid-filters"
            >
              <div className="u-grid-filters">
                <div className="u-grid-filters__inner">
                  <div className="u-grid-filters__heading">
                    <Heading element="h2" copy={"Filters"} />
                  </div>
                  <div className="u-grid-filters__buttons">
                    <Cta
                      type="button"
                      tag="button"
                      text="Apply filters"
                      onClick={applyFilters}
                    />
                    <Cta
                      type="button"
                      tag="button"
                      text="Reset filters"
                      onClick={resetFilters}
                      bgColor="white"
                    />
                  </div>
                  <div className="multi-select--filter-location-of-founder">
                    <Heading copy={"Location of co-founder"} element={"h3"} />
                    {!me ? (
                      <div className="u-grid-filters__filter-unavailable-msg">
                        You must be logged in to match to your set location
                      </div>
                    ) : (
                      <>
                        <CheckBox
                          label="Co-founder must be in my country"
                          forLabel="FLocationByCountry"
                          isSelected={FLocationByCountry}
                          onClick={this.updateValue}
                          isValid={true}
                        />
                        <CheckBox
                          label="Co-founder must be in my town/ city"
                          forLabel="FLocationByCity"
                          isSelected={FLocationByCity}
                          onClick={this.updateValue}
                          isValid={true}
                        />
                      </>
                    )}
                  </div>
                  <div className="multi-select--filter-type-of-founder">
                    <Heading copy={"Type of co-founder"} element={"h3"} />
                    <CheckBox
                      label="Show everyone who has an idea for a startup"
                      forLabel="FHasIdeaForStartup"
                      isSelected={FHasIdeaForStartup}
                      onClick={this.updateValue}
                      isValid={true}
                    />
                    <CheckBox
                      label="Show everyone who is looking to partner up on someone else's idea"
                      forLabel="FLookingToJoinStartupAsFounder"
                      isSelected={FLookingToJoinStartupAsFounder}
                      onClick={this.updateValue}
                      isValid={true}
                    />
                  </div>
                  <div className="multi-select--filter-contacts-filter">
                    {!me ? (
                      <>
                        <Heading copy={"Contact filters"} element={"h3"} />
                        <div className="u-grid-filters__filter-unavailable-msg">
                          You must be logged in to filter by contacts
                        </div>
                      </>
                    ) : (
                      <SelectDropdown
                        options={founderContactsFilters}
                        label="Contact filters"
                        forLabel="FContacts"
                        selectedOptionId={FContacts}
                        onClick={this.updateValue}
                        isValid={true}
                        validationErrorMsg=""
                      />
                    )}
                  </div>
                  <MultiSelect
                    options={skillsData}
                    selectedOptions={FHasSkills}
                    label="Only show people with the following skills"
                    selectionMax={999}
                    forLabel="FHasSkills"
                    toggleSelection={this.toggleSelection}
                    component="li"
                    isValid={true}
                    validationErrorMsg=""
                  />
                  <MultiSelect
                    options={hoursPerWeekData.filter(
                      (hourPerWeek) => hourPerWeek.itemId !== 0
                    )}
                    selectedOptions={FHoursPerWeekData}
                    label="Only show people with the following weekly availability"
                    selectionMax={999}
                    forLabel="FHoursPerWeekData"
                    toggleSelection={this.toggleSelection}
                    component="li"
                    isValid={true}
                    validationErrorMsg=""
                  />
                  <div
                    className={classNames(
                      "u-grid-filters__premium-filter u-grid-filters__premium-filter--single-checkbox",
                      {
                        "u-grid-filters__premium-filter--disabled": !isPremiumUser,
                      }
                    )}
                  >
                    {!isPremiumUser && (
                      <PremiumBadge
                        copy="Pro only"
                        showUpgradeHoverMessage={me && !isPremiumUser}
                      />
                    )}
                    <Heading copy={"Search by keyword"} element={"h3"} />
                    <TextInput
                      label="ie Fintech, Javascript, SAAS etc"
                      forLabel="FKeywordSearch"
                      type="text"
                      isDisabled={!isPremiumUser}
                      updateValue={this.updateValue}
                      value={FKeywordSearch}
                      isValid={true}
                    />
                  </div>
                  <div
                    className={classNames(
                      "u-grid-filters__premium-filter u-grid-filters__premium-filter--single-checkbox",
                      {
                        "u-grid-filters__premium-filter--disabled": !isPremiumUser,
                      }
                    )}
                  >
                    {!isPremiumUser && (
                      <PremiumBadge
                        copy="Pro only"
                        showUpgradeHoverMessage={me && !isPremiumUser}
                      />
                    )}
                    <Heading copy={"Sort users by"} element={"h3"} />
                    <CheckBox
                      label="Sort users by last active"
                      forLabel="FLastActive"
                      isSelected={FLastActive}
                      isDisabled={!isPremiumUser}
                      onClick={this.updateValue}
                      isValid={true}
                    />
                  </div>
                  <div
                    className={classNames("u-grid-filters__premium-filter", {
                      "u-grid-filters__premium-filter--disabled": !isPremiumUser,
                    })}
                  >
                    {!isPremiumUser && (
                      <PremiumBadge
                        copy="Pro only"
                        showUpgradeHoverMessage={me && !isPremiumUser}
                      />
                    )}
                    <MultiSelect
                      options={ideaStagesData.filter(
                        (ideaStage) => ideaStage.itemId !== 0
                      )}
                      selectedOptions={FIdeaStages}
                      label="Show only the following stages of startup ideas"
                      selectionMax={999}
                      forLabel="FIdeaStages"
                      toggleSelection={this.toggleSelection}
                      component="li"
                      isValid={true}
                      isDisabled={!isPremiumUser}
                      validationErrorMsg=""
                    />
                  </div>
                  <div
                    className={classNames("u-grid-filters__premium-filter", {
                      "u-grid-filters__premium-filter--disabled": !isPremiumUser,
                    })}
                  >
                    {!isPremiumUser && (
                      <PremiumBadge
                        copy="Pro only"
                        showUpgradeHoverMessage={me && !isPremiumUser}
                      />
                    )}
                    <MultiSelect
                      options={industriesData.filter(
                        (industry) => industry.itemId !== 0
                      )}
                      selectedOptions={FIndustriesData}
                      label="Show only ideas from the following industries"
                      selectionMax={999}
                      forLabel="FIndustriesData"
                      toggleSelection={this.toggleSelection}
                      component="li"
                      isValid={true}
                      isDisabled={!isPremiumUser}
                      validationErrorMsg=""
                    />
                  </div>
                  <div className="u-grid-filters__buttons u-grid-filters__buttons--bottom">
                    <Cta
                      type="button"
                      tag="button"
                      text="Apply filters"
                      onClick={applyFilters}
                    />
                    <Cta
                      type="button"
                      tag="button"
                      text="Reset filters"
                      onClick={resetFilters}
                      bgColor="white"
                    />
                  </div>
                </div>
              </div>
            </PagePopup>,
            portalNode
          )}
      </>
    );
  }
}

export default UserGridFilters;
